import type { TourDocumentStatus } from 'shared/api/tours/document-data'

export type StepState = 'complete' | 'current' | 'pending'

export interface StatusConfig {
  label: string
  steps: [StepState, StepState, StepState]
}

const upcoming: StatusConfig = {
  label: 'tourDetails.upcoming',
  steps: ['complete', 'complete', 'current'],
}

const configs: Record<TourDocumentStatus, StatusConfig> = {
  DOCUMENT_CREATED: {
    label: 'tourDetails.awaitingContract',
    steps: ['current', 'pending', 'pending'],
  },
  DOCUMENT_TO_SIGNING: {
    label: 'tourDetails.awaitingContract',
    steps: ['current', 'pending', 'pending'],
  },
  DOCUMENT_SIGNED_TO_PAY: {
    label: 'tourDetails.awaitingPayment',
    steps: ['complete', 'pending', 'pending'],
  },
  DOCUMENT_TO_TOUR: {
    label: 'tourDetails.booking',
    steps: ['complete', 'current', 'pending'],
  },
  TOUR_AWAITING_BOOKING: upcoming,
  TOUR_TO_ADDITIONAL: upcoming,
  ADDITIONAL_TO_PAID: upcoming,
  PAY_LAST_DAY: upcoming,
  PAID: upcoming,
  IN_TRIP: {
    label: 'tourDetails.inTrip',
    steps: ['complete', 'complete', 'complete'],
  },
  COMPLETED: {
    label: 'tourDetails.completed',
    steps: ['complete', 'complete', 'complete'],
  },
  CANCELLED: {
    label: 'tourDetails.cancelled',
    steps: ['pending', 'pending', 'pending'],
  },
}

export const getStatusConfig = (status: TourDocumentStatus): StatusConfig =>
  configs[status]
